import { render, staticRenderFns } from "./ViewCameraPlus.vue?vue&type=template&id=3971b1ba&scoped=true&"
import script from "./ViewCameraPlus.vue?vue&type=script&lang=js&"
export * from "./ViewCameraPlus.vue?vue&type=script&lang=js&"
import style0 from "./ViewCameraPlus.vue?vue&type=style&index=0&id=3971b1ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3971b1ba",
  null
  
)

export default component.exports